import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const HowToInstall = () => {
  const { t } = useLanguage();
  const handleDownload = () => {
    // Direct link to the beta APK
    window.open('https://expo.dev/artifacts/eas/5xguG1EpDELXbKzQw8eseM.apk', '_blank');
  };
  const stepsCopy = t('howToInstall.steps', []);
  const steps = Array.isArray(stepsCopy) ? stepsCopy : [];
  const importantNotes = t('howToInstall.notes', []);

  return (
    <section id="how-to-install" className="section-padding bg-gray-50">
      <div className="container-max">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            {t('howToInstall.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {t('howToInstall.subtitle')}
          </p>
        </div>

        {/* Installation Steps */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {steps.map((step, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg p-6 text-center">
              {/* Step Number */}
              <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-lg">{index + 1}</span>
              </div>
              
              {/* Icon */}
              <div className="w-12 h-12 bg-gradient-to-r from-green-500 to-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              
              {/* Title */}
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                {step.title}
              </h3>
              
              {/* Description */}
              <p className="text-gray-600 text-sm leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>

        {/* Download Section */}
        <div className="bg-white rounded-2xl shadow-lg p-8 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            {t('howToInstall.readyToDownload')}
          </h3>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
            {t('howToInstall.downloadDescription')}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button 
              onClick={handleDownload}
              className="btn-primary text-lg px-8 py-4"
            >
              <svg className="w-5 h-5 inline mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              {t('howToInstall.downloadButton')}
            </button>
            
            <div className="text-sm text-gray-500">
              <p>{t('howToInstall.fileSize')}</p>
              <p>{t('howToInstall.androidVersion')}</p>
            </div>
          </div>
        </div>

        {/* Important Notes */}
        <div className="mt-8 bg-yellow-50 border border-yellow-200 rounded-2xl p-6">
          <div className="flex items-start">
            <svg className="w-6 h-6 text-yellow-600 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
            <div>
              <h4 className="font-semibold text-yellow-800 mb-2">{t('howToInstall.importantNotes')}</h4>
              {Array.isArray(importantNotes) && (
                <ul className="text-yellow-700 text-sm space-y-1">
                  {importantNotes.map((note) => (
                    <li key={note}>• {note}</li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowToInstall; 